import { IApplicationState } from '../../types/redux';

export const selectCpdAvailable = (state: IApplicationState) => {
  return state.cpd.isAvailable;
};
